import React from 'react';
import {Link} from 'react-router-dom';
function FooterComponent() {
	
	return(
		<>
			<section id="c-sectionFooter">
				<div className="container">	
					<div className="c-footerColumnsWrapper">
						<div className="row">
							<div className="col-lg-6 col-md-12 col-sm-12">
								<div className="row">
									<div className="col-lg-8 col-md-12">
										<div className="c-footerLogo">
											<img src="./images/logo/finayo-logo.png" alt="" />
										</div>
										<p className="c-para18Light text-justify">
										Finayo is India’s leading green mobility embedded lending technology that aims to revolutionize the rapidly evolving EV business. Our advanced SAAS platform connects Lenders with the customers of the EV retailers, helping them make credit decisions faster and more efficiently, and thereby helping these retailers and OEMs to receive 'financing in minutes' for their customers.
										</p>
										<ul className="c-footerSocialIcons">
											<li>
												<a href={void(0)}><img src="./images/social/social_fb.png" alt="" title="" /></a>
											</li>
											<li>
												<a href={void(0)}><img src="./images/social/social_ig.png" alt="" title="" /></a>
											</li>
											<li>
												<a href="https://twitter.com/finayo_tech" target="_blank"><img src="./images/social/social_tw.png" alt="" title="" /></a>
											</li>
											<li>
												<a href="https://www.linkedin.com/company/finayotech/" target="_blank"><img src="./images/social/social_in.png" alt="" title="" /></a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="col-lg-6 col-md-12 col-sm-12">
								<div className="row">
									<div className="col-md-6 col-sm-4 col-xs-12">
										<h5 className="c-footerLinksHeading c-heading30SemiBold">Information</h5>
										<ul className="c-footerLinks">
											<li>
												<Link to='/about' className="nav-link c-scrollToDiv" data-scroll-to="#c-heroAboutUs">
													About Us
												</Link>
											</li>
											<li><a href={void(0)} className="nav-link c-scrollToDiv">Blog</a></li>
											<li><Link to='/contact' className="nav-link c-scrollToDiv" data-scroll-to="#c-ContactUs">Contact Us</Link></li>
											<li><Link to='/' className="nav-link c-scrollToDiv">Team</Link></li>
											<li><a href={void(0)} className="nav-link c-scrollToDiv">FAQ</a></li>
											<li><Link to='/career' className="nav-link c-scrollToDiv"  data-scroll-to="#c-heroAboutUs">Careers</Link></li>
										</ul>
									</div>
									<div className="col-md-6 col-sm-4 col-xs-12">
										<h5 className="c-footerLinksHeading c-heading30SemiBold">Legal</h5>
										<ul className="c-footerLinks">
											<li><a href={void(0)}>Terms &amp; Conditions</a></li>
											<li><a href={void(0)}>Privacy Policy</a></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="container-fluid c-footerCopyrightWrapper">			
					<div className="c-footerCopyright" style={{fontSize: "15px"}}>
					<span style={{fontSize: "14px"}} >Copyright &copy;</span>	2022  All Rights Reserved, Kilpi Technology and Services Pvt. Ltd.
					</div>
				</div>
			</section>
		</>
	)
}
export default FooterComponent;